import { Icon, Tooltip } from "@material-ui/core";
import { AutoResizeTextArea } from "Components/Common/Input/AutoResizeTextArea/AutoResizeTextArea";
import * as React from "react";
import i18n from "Translations/i18n";
import styles from "./Textbox.scss";

export interface IProps {
    value: string;
    id?: string;
    className?: string;
    maxHeight?: number;
    placeholder?: string;
    onChange: (newValue: string) => void;
}

interface IState {
    value: string;
    isFocussed: boolean;
}

export class Textbox extends React.Component<IProps, IState> {
    private areaRef = React.createRef();
    private textAreaClassName: string;
    private disableNewLines: boolean;

    constructor(props: IProps, textAreaClassName: string, disableNewLines: boolean = false) {
        super(props);

        this.state = {
            value: this.props.value,
            isFocussed: false
        };

        this.setFocus = this.setFocus.bind(this);
        this.onChange = this.onChange.bind(this);
        this.edit = this.edit.bind(this);

        this.textAreaClassName = textAreaClassName;
        this.disableNewLines = disableNewLines;
    }

    private setFocus(hasFocus: boolean) {
        this.setState({ isFocussed: hasFocus });
    }

    public onChange(event: React.FormEvent<HTMLTextAreaElement>) {
        this.setState({
            value: event.currentTarget.value
        });

        if (this.props.onChange) {
            this.props.onChange(event.currentTarget.value);
        }
    }

    private get textArea(): AutoResizeTextArea {
        return this.areaRef.current! as AutoResizeTextArea;
    }

    public edit() {
        this.textArea.focus();
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.value !== prevState.value) {
            partialState.value = nextProps.value;
        }

        return partialState;
    }

    public render() {
        return (
            <div className={`${styles.inputWrapper} ${this.state.isFocussed ? styles.editing : null}`}>
                <AutoResizeTextArea
                    ref={this.areaRef}
                    id={this.props.id}
                    className={`${this.textAreaClassName} ${styles.textArea} ${this.props.className}`}
                    maxHeight={this.props.maxHeight}
                    disableNewLines={this.disableNewLines}
                    onFocus={() => this.setFocus(true)}
                    onBlur={() => this.setFocus(false)}
                    onChange={this.onChange}
                    value={this.state.value}
                    placeholder={this.props.placeholder} />
                <Tooltip title={i18n.t("common.edit")}>
                    <Icon className={styles.editIcon} onClick={this.edit}>edit</Icon>
                </Tooltip>
            </div>
        );
    }
}

export default Textbox;


// WEBPACK FOOTER //
// ./src/Components/Common/Input/TextBoxes/Textbox.tsx